<template>
  <v-container fluid class="pa-3">
    <v-row>

      <!-- Ranking -->
      <v-col cols="12" md="6">
        <Ranking />
      </v-col>

      <!-- Info institucional -->
      <v-col cols="12" md="6">

        <!-- Logo -->
        <div class="text-center mb-4">
          <img :src="$store.state.unidad.logo" alt="Logo" class="home-logo" />
        </div>

        <!-- Misión -->
        <v-card outlined class="mb-3">
          <div class="home-section-header">
            <v-icon small color="amber darken-2" class="mr-2">mdi-flag-outline</v-icon>
            <span class="white--text caption font-weight-bold letter-spacing">NUESTRA MISIÓN</span>
          </div>
          <v-card-text class="body-2 grey--text text--darken-2 py-3">
            {{ $store.state.unidad.mision }}
          </v-card-text>
        </v-card>

        <!-- Visión -->
        <v-card outlined class="mb-3">
          <div class="home-section-header">
            <v-icon small color="amber darken-2" class="mr-2">mdi-eye-outline</v-icon>
            <span class="white--text caption font-weight-bold">NUESTRA VISIÓN</span>
          </div>
          <v-card-text class="body-2 grey--text text--darken-2 py-3">
            {{ $store.state.unidad.vision }}
          </v-card-text>
        </v-card>

        <!-- Valores -->
        <v-card outlined>
          <div class="home-section-header">
            <v-icon small color="amber darken-2" class="mr-2">mdi-star-circle-outline</v-icon>
            <span class="white--text caption font-weight-bold">NUESTROS VALORES</span>
          </div>
          <v-card-text class="py-3">
            <div class="home-valores-grid">
              <div v-for="(val, i) in valores" :key="i" class="home-valor-item">
                <v-icon x-small :color="val.color" class="mr-1">{{ val.icon }}</v-icon>
                <span class="caption font-weight-medium">{{ val.text }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card outlined>
          <div class="home-section-header home-section-header--interest">
            <v-icon small color="amber darken-2" class="mr-2">mdi-compass-outline</v-icon>
            <span class="white--text caption font-weight-bold"> SITIOS DE INTERES: </span>
          </div>
          <v-card-text class="py-3">
            <div class="home-valores-grid">
              <div v-for="(val, i) in sitios" :key="i" class="home-valor-item">
                <a :href="val.value" target="_blank">
                  <v-icon x-small :color="val.color" class="mr-1">{{ val.icon }}</v-icon>
                  <span class="caption font-weight-medium">{{ val.text }}</span>
                </a>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Ranking from '@/views/Ranking.vue';

  export default {
    name: 'home',
    components: { Ranking },
    data() {
      return {
        valores: [
          { text: 'Espíritu de triunfo', icon: 'mdi-lightning-bolt',       color: 'amber darken-2' },
          { text: 'Trabajo en equipo',   icon: 'mdi-account-group',        color: 'amber darken-2' },
          { text: 'Cooperación',         icon: 'mdi-handshake-outline',    color: 'amber darken-2' },
          { text: 'Identidad',           icon: 'mdi-shield-star-outline',  color: 'amber darken-2' },
          { text: 'Responsabilidad',     icon: 'mdi-check-decagram',       color: 'amber darken-2' },
          { text: 'Ética',               icon: 'mdi-scale-balance',        color: 'amber darken-2' },
          { text: 'Respeto',             icon: 'mdi-heart-outline',        color: 'amber darken-2' },
          { text: 'Creatividad',         icon: 'mdi-lightbulb-outline',    color: 'amber darken-2' },
          { text: 'Satisfacción',        icon: 'mdi-emoticon-happy-outline', color: 'amber darken-2' },
          { text: 'Excelencia',          icon: 'mdi-trophy-outline',       color: 'amber darken-2' },
        ],
        sitios: [
          {text:'Sistema Académico ESAM Portal+', value:'https://academico-sedes.esam.edu.bo/', icon: 'mdi-school-outline', color: 'amber darken-2'},
          {text:'Bolsa de Trabajo y Servicios de Talento Humano', value:'https://esamtalentum.com/', icon: 'mdi-briefcase-outline', color: 'amber darken-2'},
          {text:'Revista cientifica - Scientific Universe ESAM', value:'https://blog.esam.edu.bo/', icon: 'mdi-book-open-page-variant-outline', color: 'amber darken-2'},
          {text:'Biblioteca Virtual', value:'https://esam.edu.bo/biblioteca-virtual/', icon: 'mdi-bookshelf', color: 'amber darken-2'},
          {text:'Calendario Academico', value:'https://esam.edu.bo/calendario-academico/', icon: 'mdi-calendar-month-outline', color: 'amber darken-2'},
          {text:'Plataforma de Webinars', value:'https://esam.edu.bo/webinars/', icon: 'mdi-video-outline', color: 'amber darken-2'},
          {text:'Portal del estudiante', value:'https://estudiantes.esam.edu.bo/', icon: 'mdi-account-box-outline', color: 'amber darken-2'},
          {text:'TH Person', value:'https://thperson.esam.edu.bo/', icon: 'mdi-account-tie-outline', color: 'amber darken-2'},
          {text:'Recursos humanos', value:'https://rrhh.esam.edu.bo/', icon: 'mdi-account-tie-outline', color: 'amber darken-2'},
          {text:'Esam Siglo XX', value:'https://ge-pagos.esam.edu.bo/', icon: 'mdi-account-tie-outline', color: 'amber darken-2'},
          {text:'Sitio Web ESAM', value:'https://esam.edu.bo/', icon: 'mdi-web', color: 'amber darken-2'},
        ]
      };
    },
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style>
.home-logo {
  max-width: 200px;
  max-height: 120px;
  object-fit: contain;
}
.home-section-header {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  border-radius: 4px 4px 0 0;
  background: #0c55b2;
  border-left: 4px solid #d6b11f;
}
.home-section-header--interest {
  border-left-color: #f2c94c;
}
.home-valores-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}
.home-valor-item {
  display: flex;
  align-items: center;
  padding: 5px 8px;
  background: #f6f7f9;
  border-radius: 6px;
  border-left: 3px solid #d6b11f;
}
</style>
